import { OPPORTUNITY_CARD_TYPES } from '@components/OpportunityListing/utils/constants';
import React from 'react';

const CornerElementSvg = ({ isFestiveDeal, isAdminDeal }) => {
    const getSvgData = () => {
        if (isAdminDeal) {
            return {
                stroke: '#003975',
                gradient: null,
            };
        } else if (isFestiveDeal) {
            return {
                stroke: 'url(#paint0_linear_36047_111622)',
                gradient: (
                    <defs>
                        <linearGradient
                            id="paint0_linear_36047_111622"
                            x1="28"
                            y1="0"
                            x2="0"
                            y2="28"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#E6CD76" />
                            <stop offset="1" stopColor="#B7982D" />
                        </linearGradient>
                    </defs>
                ),
            };
        } else {
            return {
                stroke: '#D6E4F0',
                gradient: null,
            };
        }
    };


    const { stroke, gradient } = getSvgData()

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
        >
            <path
                d="M0 0H28L14.5105 20.2342C11.2761 25.0858 5.83095 28 0 28V0Z"
                fill="white"
            />
            <mask
                id="mask0"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="28"
                height="28"
            >
                <path
                    d="M0 0H28L14.5105 20.2342C11.2761 25.0858 5.83095 28 0 28V0Z"
                    fill="#FFF9EF"
                />
                <path
                    d="M0 0H28L14.5105 20.2342C11.2761 25.0858 5.83095 28 0 28V0Z"
                    stroke="#003975"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M28 0L14.5105 20.2342C11.2761 25.0858 5.83095 28 0 28V28"
                    stroke={stroke}
                    strokeWidth="1"
                />
            </g>
            {gradient}
        </svg>
    );
};

export default CornerElementSvg;
